import { TOOL_TYPES } from '../store/useToolStore';

/**
 * Single source of truth for:
 * - legacyPath: current /tools/* routes (kept working, redirected)
 * - seoPath: new root slugs (canonical)
 * - toolType: zustand TOOL_TYPES
 * - seoKey: key in SEO_DATA
 *
 * NOTE: seoKey is also used to drive on-page content blocks.
 */
export const TOOL_SLUGS = [
  {
    seoKey: 'gradient',
    toolType: TOOL_TYPES.GRADIENT,
    legacyPath: '/tools/gradient',
    seoPath: '/swiftui-gradient-generator',
  },
  {
    seoKey: 'loader',
    toolType: TOOL_TYPES.LOADER,
    legacyPath: '/tools/loader',
    seoPath: '/swiftui-loader-generator',
  },
  {
    seoKey: 'card',
    toolType: TOOL_TYPES.CARD,
    legacyPath: '/tools/card',
    seoPath: '/swiftui-card-generator',
  },
  {
    seoKey: 'animation',
    toolType: TOOL_TYPES.ANIMATION,
    legacyPath: '/tools/animation',
    seoPath: '/swiftui-animation-generator',
  },
  {
    seoKey: 'alert',
    toolType: TOOL_TYPES.ALERT,
    legacyPath: '/tools/alert',
    seoPath: '/swiftui-alert-generator',
  },
  {
    seoKey: 'photoPicker',
    toolType: TOOL_TYPES.PHOTO_PICKER,
    legacyPath: '/tools/photo-picker',
    seoPath: '/swiftui-photo-picker-generator',
  },
  {
    seoKey: 'jsonToModel',
    toolType: TOOL_TYPES.JSON_TO_MODEL,
    legacyPath: '/tools/json-to-model',
    seoPath: '/json-to-swift-codable',
  },
  {
    seoKey: 'apiGenerator',
    toolType: TOOL_TYPES.API_GENERATOR,
    legacyPath: '/tools/api-generator',
    seoPath: '/swift-api-client-generator',
  },
  {
    seoKey: 'postmanImporter',
    toolType: TOOL_TYPES.POSTMAN_IMPORTER,
    legacyPath: '/tools/postman-importer',
    seoPath: '/postman-to-swift-api-generator',
  },
  // Storyboard converter stays “available” but not publicly linked by default
  {
    seoKey: 'storyboardConverter',
    toolType: TOOL_TYPES.STORYBOARD_CONVERTER,
    legacyPath: '/tools/storyboard-converter',
    seoPath: '/uikit-to-swiftui-converter',
  },
  // New tools (to be implemented)
  {
    seoKey: 'shadow',
    toolType: TOOL_TYPES.SHADOW,
    legacyPath: '/tools/shadow',
    seoPath: '/swiftui-shadow-generator',
  },
  {
    seoKey: 'button',
    toolType: TOOL_TYPES.BUTTON,
    legacyPath: '/tools/button',
    seoPath: '/swiftui-button-builder',
  },
  {
    seoKey: 'grid',
    toolType: TOOL_TYPES.GRID,
    legacyPath: '/tools/grid',
    seoPath: '/swiftui-grid-generator',
  },
  {
    seoKey: 'palette',
    toolType: TOOL_TYPES.PALETTE,
    legacyPath: '/tools/color-palette',
    seoPath: '/swiftui-color-palette-generator',
  },
];

const normalizePath = (path) => (path || '').split('?')[0].split('#')[0];

export const getToolSlugByPath = (path) => {
  const p = normalizePath(path);
  return TOOL_SLUGS.find((t) => t.seoPath === p || t.legacyPath === p) || null;
};

export const getSeoPathForLegacyPath = (legacyPath) => {
  const match = TOOL_SLUGS.find((t) => t.legacyPath === normalizePath(legacyPath));
  return match?.seoPath || null;
};

export const getLegacyPathForSeoPath = (seoPath) => {
  const match = TOOL_SLUGS.find((t) => t.seoPath === normalizePath(seoPath));
  return match?.legacyPath || null;
};

